<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">My Student's Documents</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Student Info -->
    <div class="card">
      <div class="card-body pb-1 pt-3">
        <div class="row">
          <div class="col-sm-3">
            <label class="mr-2"><b>Student ID: </b></label>{{ studentID }}
          </div>
          <div class="col-sm-3">
            <label class="mr-2"><b>Name:</b></label>
            {{ studentName }}
          </div>
          <div class="col-sm-3">
            <label class="mr-2"><b>Email:</b></label>
            {{ studentEmail }}
          </div>
        </div>
      </div>
    </div>
    <!-- /Student Info -->

    <!-- Table Result -->
    <document-table
      :uploaderUserType="userTypeInstructor"
      type="Student Document"
      :userId="$route.params.id"
    ></document-table>
    <!-- /Table Result -->

    <!-- Button Back -->
    <div class="text-center mt-4">
      <router-link
        class="btn btn-primary"
        :to="{ name: 'instructorMyStudents' }"
      >
        <i class="fa fa-reply mr-2"></i>Back to My Students
      </router-link>
    </div>
    <!-- /Button Back -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import DocumentTable from "../../Shared/DocumentTable.vue";
export default {
  components: {
    DocumentTable,
  },
  data() {
    return {
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      studentID: "",
      studentName: "",
      studentEmail: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  methods: {
    getStudentDetail() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.student
        .getStudentDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let data = response.data.data;
            this.studentID = data.UserName;
            this.studentName = data.Name;
            this.studentEmail =
              data.Emails && data.Emails.length ? data.Emails[0].Email : null;
          } else {
            this.$store.state.isLoading = false;
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getStudentDetail();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SchoolUser/Instructor/MyStudentsViewDocuments.vue